<template>
  <div class="orders">
      <Loader v-show="loading"/>
      <div  v-show="!loading">
            <div class="not_orders_view" v-if="orderTitle.message == 'Object with this data not found'">
                <h3>
                    У вас нет истории заказов
                </h3>
            </div>
            <div class="header_products" v-if="orderTitle.message != 'Object with this data not found'">
                        <div class="header_products_title">
                            <p>Номер заказа</p>
                        </div>
                        <div class="header_products_title">
                            <p>
                                Статус
                            </p>
                        </div>
                        <div class="header_products_title">
                            <p>
                                Сумма заказа
                            </p>
                        </div>
                        <div class="header_products_title">
                            <p>
                                Бонус
                            </p>
                        </div>
            </div>

            <v-expansion-panels v-if="orderTitle.message != 'Object with this data not found'" accordion>
                <v-expansion-panel
                    v-for="orderTitleId in orderTitle"
                    :key="orderTitleId.id"
                >
                <v-expansion-panel-header>
                    <div class="header_products_sub">
                        <div 
                            class="header_products_title_sub"
                        >
                            <p>{{orderTitleId.id}}</p>
                        </div>
                        <div class="header_products_title_sub">
                            <p>{{orderTitleId.status}}</p>
                        </div>
                        <div class="header_products_title_sub">
                            <p>{{orderTitleId.sum}} ₸</p>
                        </div>
                        <div class="header_products_title_sub">
                            <p>{{orderTitleId.bonuses}}</p>
                        </div>
                    </div>
                </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div 
                            class="product_table"
                            v-for="orderId in orderTitleId.products"
                            :key="orderId.id"
                        >
                            <div v-if="orderId.product" class="product_table_block">
                                <div class="product_table_block_img">
                                  <img
                                      v-if="orderId.product.img[0]"
                                      :src="'https://ecodom04.com/backend/'+ orderId.product.img[0]"
                                      alt="images"
                                  >
                                  <img
                                      v-if="!orderId.product.img[0]"
                                      src="../assets/not_found.png"
                                      alt="images"
                                  >
                                </div>
                                <div class="product_table_block_desk">
                                    <h3>
                                        {{orderId.product.title}}
                                    </h3>
                                    <p>Сумма: <b>{{orderId.product.price}}</b> ₸</p>
                                    <p>Количество: <b>{{orderId.product_count}}</b></p>
                                </div>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
      </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Loader from '@/components/Loader'

export default {
  name: 'orders',
  components: {
      Loader
  },
  data () {
      return {
          orderTitle: [],
          loading: true
      }
  },
  methods: {
     getOrders() {
        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.$apiURI + 'public/order/get',
            data: {
                token: this.USER[0]
            }
        })
        .then((response) => {
            this.orderTitle = response.data
            this.loading = false
        })  
        .catch((error) => {
            console.log(error);
        });
     },
  },
  mounted() {
    this.getOrders()
  },
  computed: {
    ...mapGetters(['USER']),
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

.orders {
    width: 100%;
    margin: 0 auto;
     
    .not_orders_view {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        h3 {
            font-size: 20px;
        }
    }
    .product_table_block {
        width: 100%;
        padding: 10px;
        border: 2px dotted #ccc;
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        @media (max-width: @baseMedia) {
            padding: 5px;
        }
        .product_table_block_img {
            width: 150px;
            height: 100px;
            background: #fff;
            border: 1px solid #ccc;
            border-radius: 5px;
            overflow: hidden;
            margin-right: 10px;
            text-align: center;
            @media (max-width: @baseMedia) {
                margin-right: 5px;
                width: 110px;
                height: 72px;
            }
            img {
                height: 100%;
                &:hover {
                    transition: 2s;
                    cursor: pointer;
                    height: 110%;
                }
            }
        }
        .product_table_block_desk {
            width: 79%;
            h3 {
                margin-bottom: 10px;
                @media (max-width: @baseMedia) {
                    font-size: 15px;
                }
            }
            p {
                @media (max-width: @baseMedia) {
                    font-size: 14px;
                }
            }
        }
    }
    .header_products {
        width: 100%;
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-left: 24px;
        background: #fff;
        @media (max-width: @baseMedia) {
            padding-left: 0px;
        }
        .header_products_title {
            width: 23.5%;
            border: 1px solid #4d5432;
            padding-top: 10px;
            padding-bottom: 10px;
            text-align: center;
            font-weight: bold;
            text-transform: uppercase;
            color: #4d5432;
            @media (max-width: @baseMedia) {
                padding-top: 4px;
                font-size: 12px;
                padding-bottom: 4px;
            }
        }
    }
    .v-expansion-panel-header {
        padding: 0px 24px;
        background: #fff;
        color: #4d5432;
        border-radius: 0px;
        height: auto;
        @media (max-width: @baseMedia) {
            padding: 0px 0px;
        }
    }
    .v-expansion-panel-content__wrap {
        padding: 0 7px 16px;
    }
    .header_products_sub {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        &:hover {
            background: #dadada;
        }
        .header_products_title_sub {
            width: 25%;
            border: 1px solid #4d5432;
            padding-top: 10px;
            padding-bottom: 10px;
            @media (max-width: @baseMedia) {
                padding-top: 4px;
                font-size: 11px;
                padding-bottom: 4px;
            }
            color: #4d5432;
        }
    }
}
</style>